import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetArticleListSucceed, EGetArticleListActionType } from './types';
import { IArticleList } from '../../../types/articleList';

export const getArticleListSucceed: (data: IArticleList) => TGetArticleListSucceed = actionGenerator<
  EGetArticleListActionType.Succeed,
  IArticleList
>(EGetArticleListActionType.Succeed);
